import { Box, Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import { Localizations } from "../../../Shared/sharedTypes";

interface propsType {
    next: () => void;
    localizations: Localizations;
}
export default function WhatToExpect({ localizations, next }: propsType) {
    return (
        <>
            <Grid item className="PhaseTopSection">
                <Box m={3}>
                    <Typography variant="h5">{localizations.whatToExpectHeader}</Typography>
                    <Typography variant="body1">{localizations.whatToExpectBody}</Typography>
                </Box>
            </Grid>
            <Grid item className="footer">
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    fullWidth
                    // startIcon={<FlightTakeoff />}
                    onClick={() => next()}
                >
                    {localizations.next}
                </Button>
            </Grid>
        </>
    );
}
